import { render, staticRenderFns } from "./api-service.vue?vue&type=template&id=df36b9fe&scoped=true&"
import script from "./api-service.vue?vue&type=script&lang=js&"
export * from "./api-service.vue?vue&type=script&lang=js&"
import style0 from "./api-service.vue?vue&type=style&index=0&id=df36b9fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df36b9fe",
  null
  
)

export default component.exports